import layout from '@/components/common/layout';
import enterList from '../views/entercontract/list';

export default [
    {
        path: '/entercontract',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "企业合同",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '10',// 父选项
                        child: 'enterprise_list',// 子选项
                    }
                },
                component: enterList,
            },
        ]
    },
];
